import { Component, Injectable, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { environment } from 'environments/environment';
import * as _ from 'lodash';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { SocialService } from '../../../../../common/services/Social.service';
import { Observable } from 'rxjs/Rx';


declare var $: any;
const FACEBOOK_URL = environment.url_ottgateway;
const ZALO_URL = environment.url_ottgateway;

@Component({
    moduleId: module.id,
    selector: "page",
    templateUrl: './page.component.html',
    styleUrls: ['./page.css'],
    providers: [SocialService]
})

@Injectable()
export class PageComponent implements OnInit {
    @ViewChild('templatePage') templatePage: ElementRef;

    public user: any;
    public list: any = [];
    public pages: any = [];
    public objPages : any = {};
    public access_token: any;
    public check_exist : any = {};
    public modalRef2: any;
    public linkLogin: any;
    public no_image: any = "assets/images/img_notfound.png";

    constructor(
        private socialService: SocialService,
        private modalService: BsModalService,
        private toastr: ToastrService
    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.loadPage();
    }

    loadPage() {
      this.socialService.listPage(this.user.tenant_id).subscribe(res => {
        console.log(res.data);
        this.list = res.data;
        this.list.forEach(e => {
            this.check_exist[e.pageId] = true;
            switch (e.type) {
              case 0:
                e.type = 'zalo';
                break;
              case 1:
                e.type = 'facebook';
                break;
              case 2:
                e.type = 'tiktok';
                break;
            }
        });
      })
    }


    addPage(tab) {
      switch (tab) {
        case 'zalo':
          this.linkLogin = ZALO_URL + "/zalologin.html?access_token=" + localStorage.getItem('Access-Token');
          break;
        case 'facebook':
          this.linkLogin = FACEBOOK_URL + "/facebooklogin.html?access_token=" + localStorage.getItem('Access-Token');
          break;
      }
      this.login();
    }


    checkUse(page_id) {
        this.check_exist[page_id] = this.check_exist[page_id] ? false: true;
    }

    deletePage(page_id) {
        var y = confirm("Bạn có muốn xóa trang này không?");
        if(y){
            this.socialService.deletePage(page_id).subscribe(res => {
                if(!res.error && res.status == 200) {
                    this.toastr.success('Xóa page thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.loadPage();
                }
            })
        }
        
    }

    savePage() {
        let observableBatch = [];
        for(let e in this.check_exist) {
            if(this.check_exist[e]) {
                let payload = {
                    access_token : this.objPages[e].access_token,
                    page_id: this.objPages[e].id,
                    page_name: this.objPages[e].name,
                    category : this.objPages[e].category
                }
                observableBatch.push(
                    this.socialService.addPage(payload)
                )
            }
        }

        Observable.forkJoin(observableBatch).subscribe(data => {
            this.toastr.success('Lưu page thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            this.loadPage();
            this.modalRef2.hide();
        })

    }

    login() {
        // const loginOptions: LoginOptions = {
        //     enable_profile_selector: true,
        //     return_scopes: true,
        //     scope: 'read_page_mailboxes, public_profile, email, manage_pages, pages_show_list, pages_messaging, publish_pages'
        // };
        //
        // this.fb.login(loginOptions)
        //     .then((res: LoginResponse) => {
        //         console.log('Logged in');
        //         this.getLongLiveToken(res.authResponse.accessToken);
        //     })
        //     .catch(this.handleError);
      window.open(this.linkLogin , '_blank');
    }

    private handleError(error) {
        console.error('Error processing action', error);
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/pages/page.component.ts